import React from 'react';

import createSvgIcon from './hoc/createSvgIcon';

const FontColor = createSvgIcon(
  ({ underlinedColor = 'black' }) => (
    <>
      <path
        d="M3 14H5.42L6.69 10.42H12.34L13.6 14H16.02L10.76 0H8.26L3 14ZM7.42 8.39L9.45 2.6H9.57L11.6 8.39H7.42Z"
        fill="black"
        fillOpacity="0.6"
      />
      <rect y="17" width="20" height="4" fill={underlinedColor} />
    </>
  ),
  'FontColor',
  '-2 0 24 20'
);

export default FontColor;
